import React, { useState } from 'react';
import styled from 'styled-components';
import Select from "react-select";
import { Controller } from 'react-hook-form';
import { motion } from 'framer-motion';
const StyledDropDown = styled.div`

    position: relative;
    margin-right: 16px;
    margin-bottom: 28px;
    flex-grow: 1;
    flex-basis: 0;
    @media screen and (max-width: 710px) {
        margin-right: 0;
    }
    @media screen and (min-width: 720px) and (max-width: 1024px) {
        margin-right: 0;
    }
    label {
        position: absolute;
        top: 3px;
        left: 16px;
        font-size:12px;
        ${props => (props.hasError ? 'color: #cf0a2c;' : 'color: #757575;')}
    }
    input:focus {
        outline:none;
    }
    .required-indicator {
        position: absolute;
        right: 0;
        top: 0;
        width: 6px;
        height: 56px;
        background-color: ${props =>
        props.hasError ? '#cf0a2c' : props.theme.colors.primaryYellow};
        transition: background-color 0.2s;
    }
    .css-1okebmr-indicatorSeparator{
        display:none;
    }
    .css-tlfecz-indicatorContainer{
        color:#757575;
    }
    .css-1iz7zek-placeholder:before{
        display:none;
    }
    .css-1oluaps-Input:before{
        display:none;
    }
    .validationErrText{
        font-size: 12px;
        color: #cf0a2c;
        line-height: 14px;
        position: absolute;
        padding-top: 5px;
    }
`;
const dot = (color = '#ccc') => ({
    alignItems: 'center',
    display: 'flex',
    color: '#757575',
    ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
    },
});

const ErrorVariants = {
    show: { opacity: 1 },
    hide: { opacity: 0 },
};

function HookFormSelect({
    hasError,
    errorText,
    label,
    register,
    name,
    required,
    SelectedValue,
    options,
    control,
    defaultValue,
}) {
    const [hasValue, setHasValue] = useState(SelectedValue ? true : false);
    const colorStyles = {
        control: (styles, state) => ({
            ...styles,
            backgroundColor: 'white',
            borderRadius: '0px',
            borderColor: 'none',
            boxShadow: 'none',
            border: state.isFocused ? '2px solid #F9A11B' : '1px solid rgb(181, 181, 181)',
            height: '56px',
            ':hover': {
                ...styles[':hover'],
                border: '2px solid #F9A11B'
            },
            ':focus': {
                ...styles[':focus'],
                border: '2px solid #F9A11B'
            },
        }),
        input: styles => ({
            ...styles,
        }),
        placeholder: styles => ({
            ...styles,
            margin: '0 0 0 8px',
            color: '#404041',
            fontWeight: '600',
            ':before': {
                ...styles[':before'],
                display: 'none'
            }
        }),
        singleValue: (styles) => ({ ...styles, color: '#404041', fontWeight: '600', margin: '0 0 0 8px' }),
        option: (styles, state) => ({
            ...styles,
            color: state.isSelected ? '#fff' : '#757575',
            cursor: 'default',
            backgroundColor: state.isSelected ? "#F9A11B" : '',
            height: 'auto',
            ':hover': {
                ...styles[':hover'],
                color: '#fff',
                backgroundColor: '#F9A11B',
            }
        }),
    };
    if (required) {
        errorText = `${label} is required`
    }
    return (
        <StyledDropDown
            hasError={hasError}
            required={required}
            hasValue={hasValue}>
            <Controller
                as={<Select options={options} isSearchable={false} value={SelectedValue} defaultValue={defaultValue} />}
                name={name}
                control={control}
                placeholder="Select One"
                valueName="selected"
                styles={colorStyles}
                rules={{ required: required }}
            />
            <label htmlFor={name}>{label}</label>
            <motion.p
                className="validationErrText"
                initial={{ opacity: 0 }}
                variants={ErrorVariants}
                animate={hasError ? 'show' : 'hide'}
            >
                {errorText}
            </motion.p>
            {required && <span className="required-indicator"></span>}
        </StyledDropDown>
    )
}

HookFormSelect.propTypes = {};

export default HookFormSelect;